module.exports = __webpack_public_path__ + "static/img/1.3cadbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/1.png
// module id = G8aZ
// module chunks = 0